import utilsWindow from '../../utils/window'
import {
  getPostActions,
  getPostActionsFromPdo,
  confirmAdminAction,
  sendServerAdminAction,
} from './../../providers/postActions/postActionsProvider'

export const FETCH_POST_ACTIONS = 'FETCH_POST_ACTIONS'
export const LOADING_POST_ACTIONS = 'LOADING_POST_ACTIONS'
export const FETCH_POST_ACTIONS_SUCCESS = 'FETCH_POST_ACTIONS_SUCCESS'
export const FETCH_POST_ACTIONS_FAILED = 'FETCH_POST_ACTIONS_FAILED'

export const confirmAndExecAdminAction = adminAction => dispatch => {
  const confirmationResult = confirmAdminAction(adminAction)
  if (confirmationResult) {
    sendServerAdminAction(adminAction)
      .then(response => {
        response.success && alert(`Successfully ${adminAction.text}`)
        if (typeof response.redirect !== 'undefined') {
          utilsWindow.navigateTo(response.redirect)
        }
      })
      .catch(() => {
        alert(
          `something went wrong while trying to ${adminAction.text}. It might have work and might have not. please try again or verify`
        )
      })
  }
}

export const loadingPostActions = isLoading => ({
  type: LOADING_POST_ACTIONS,
  newState: { isLoading },
})

const fetchPostActionsFailed = () => ({
  type: FETCH_POST_ACTIONS_FAILED,
  newState: { hasErrors: true },
})

const fetchPostActionsSuccess = optionsList => ({
  type: FETCH_POST_ACTIONS_SUCCESS,
  newState: { optionsList, hasErrors: false },
})

export const fetchPostActions = (postId, fetchFromServer) => dispatch => {
  const getPostActions = fetchFromServer ? getPostActions : getPostActionsFromPdo

  dispatch(loadingPostActions(true))
  return getPostActions(postId)
    .then(({ data }) => {
      return dispatch(fetchPostActionsSuccess(data.options))
    })
    .then(() => dispatch(loadingPostActions(false)))
    .catch(error => dispatch(fetchPostActionsFailed()))
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/postActions/postActions.actions.js